import React from "react";
import ReactDOM from "react-dom";
// Store
import { routerMiddleware, ConnectedRouter } from "connected-react-router";
import rootReducer from "./reducers";
import { createStore, applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
// Nav
import { createBrowserHistory } from "history";
import { Route, Switch } from "react-router-dom";
import indexRoutes from "./routes";

import MomentUtils from "@date-io/moment";
import "./index.css";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import Config from './components/common/Config';

export const history = createBrowserHistory();

if (window.Cypress) {
  window.tgHistory = history;
}

const composeEnhancers =
  (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      trace: true,
      traceLimit: 25
    })) ||
  compose;

function configureStore(preloadedState) {
  return createStore(
    rootReducer(history),
    preloadedState,
    compose(composeEnhancers(applyMiddleware(routerMiddleware(history), thunk)))
  );
}

const store = configureStore();

// Store creation before connected-react-router
// const store = createStore(
//   rootReducer,
//   composeEnhancers(applyMiddleware(thunk))
// );

if (window.Cypress) {
  window.store = store;
}

const theme = createMuiTheme({
  typography: {},
  palette: {
    primary: {
      main: "#001A70"
    },
    secondary: {
      main: "#ff4400",
      contrastText: "#ffcc00"
    },
    tertiary: {
      main: "#AAAAAA"
    }
  }
});

ReactDOM.render(
  <React.StrictMode>
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <MuiThemeProvider theme={theme}>
            <Config>
              <Switch>
                {indexRoutes.map((prop, key) => {
                  return (
                    <Route
                      path={prop.path}
                      component={prop.component}
                      key={key}
                    />
                  );
                })}
              </Switch>
            </Config>
          </MuiThemeProvider>
        </ConnectedRouter>
      </Provider>
    </MuiPickersUtilsProvider>
  </React.StrictMode>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js